'use client'
import { useSearchParams } from 'next/navigation'
import Link from 'next/link'

import { EdsnText } from '@8percent/edsn-react'

type TabProps = {
  isWinnerContent: boolean
}

export default function Tab(props: TabProps) {
  const params = useSearchParams()
  const state = params?.get('state')

  return (
    <div className="box-content h-[62px] pc:px-[16px] border-0 border-b border-solid border-[#dee2e5]">
      <div className="px-[16px] flex gap-[24px] pc:px-0">
        <div
          className={`h-[62px] flex items-center cursor-pointer border-0 border-b-[3px] border-solid ${!state ? 'border-black' : 'border-transparent'}`}
        >
          <Link href={{ pathname: '/' }}>
            <EdsnText variant={!state ? 'body-l-strong' : 'body-l-regular'} as="h3">
              진행중
            </EdsnText>
          </Link>
        </div>

        {props.isWinnerContent ? (
          <div
            className={`h-[62px] flex items-center cursor-pointer border-0 border-b-[3px] border-solid ${state === 'winner' ? 'border-black' : 'border-transparent'}`}
          >
            <Link href={{ pathname: '/', query: { state: 'winner' } }}>
              <EdsnText variant={state === 'winner' ? 'body-l-strong' : 'body-l-regular'} as="h3">
                당첨자 발표
              </EdsnText>
            </Link>
          </div>
        ) : (
          ''
        )}

        <div
          className={`h-[62px] flex items-center cursor-pointer border-0 border-b-[3px] border-solid ${state === 'finish' ? 'border-black' : 'border-transparent'}`}
        >
          <Link href={{ pathname: '/', query: { state: 'finish' } }}>
            <EdsnText variant={state === 'finish' ? 'body-l-strong' : 'body-l-regular'} as="h3">
              종료
            </EdsnText>
          </Link>
        </div>
      </div>
    </div>
  )
}
